import React from 'react';

//component
import Icon from '../../../../global/icons/Icon';
import PanelButton from '../../../../global/buttons/PanelButton';

//interfaces
import { IconLibrary } from '../../../../../interfaces/icon/IconLibrary';
import { IAdvancedOptionsButton } from '../../../interfaces/IFormBuilderButtons';



const AdvancedSettingsButton = ({ showAdvancedOptions, setShowAdvancedOptions }: IAdvancedOptionsButton ) => {
    
    return (
        <PanelButton 
            className='advanced-settings-button' 
            content={
                <>
                <span className='advanced-options-button-text'>Advanced Options</span>
                <Icon className={`${showAdvancedOptions ? "show-advanced-options" : ""}`} iconName={IconLibrary.CHEVRON_DOWN} color='var(--thriveGreyDark)' sizeInPx='9' />
                </>
            } 
            ariaLabel={`${showAdvancedOptions ? "Hide advanced options for form element." : "Show advanced options for form element."}`} 
            onButtonClick={setShowAdvancedOptions} 
        />
    );
};

export default AdvancedSettingsButton 